import LinkButton from 'components/controls/links/link-button';
import ChevronR from 'assets/icons/chevron-r.svg';
import styles from './component-header.module.scss';
import MarkdownParser from 'components/rich-text/markdown-parser';

export interface IProps {
	description?: string;
	link?: {
		cta: string;
		url: string;
	};
	title: string;
}

const ComponentHeader = ({ title, description, link }: IProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.titleAndLinkWrapper}>
				<div>
					<h2 className={styles.title}>
						<MarkdownParser>{title}</MarkdownParser>
					</h2>
				</div>
				{link?.url && link?.cta ? (
					<div className={styles.cta}>
						<LinkButton
							href={link.url}
							text={link.cta}
							rightIcon={<ChevronR />}
						/>
					</div>
				) : null}
			</div>
			{description && (
				<p className={styles.description}>
					<MarkdownParser>{description}</MarkdownParser>
				</p>
			)}
		</div>
	);
};

export default ComponentHeader;
